import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SvgComponent } from '@quikr/ui';
import CommonIcons from '@quikr/ui/src/assets/common-sprite.svg';

const Wrapper = styled.article`
  /* dFA class is not to be used because of specificity issue in wrapper components */
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 12px 0;
  padding: 12px 16px;
  background: #fff7ac;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

  a {
    color: unset;
  }

  .cPrimary {
    color: ${({ theme }) => theme.colors.Primary};
  }
  .mb8 {
    margin-bottom: 8px;
  }
  .tdU {
    text-decoration: underline;
  }
`;

const BewareOfScammers = ({ className }) => {
  return (
    <Wrapper className={`bt3 fwM ${className || ''}`}>
      <SvgComponent
        className="fs0"
        width="38"
        height="34"
        svgSprite={CommonIcons}
        id="caution"
        aria-label="Caution Icon"
      />
      <div>
        <p className="mb8">
          <strong className="cPrimary">Beware of Scammers!</strong> NEVER pay any money to anyone
          promising a Job or Interview.
        </p>
        <p>
          Quikr never asks candidates for any money and does not guarantee jobs. In case of
          suspicion, call us at{' '}
          <a className="dIF fwB" href="tel:08066095795">
            080-66095795
          </a>{' '}
          or write at{' '}
          <a className="tdU" href="mailto:jobsupport@quikr.com">
            jobsupport@quikr.com
          </a>
        </p>
      </div>
    </Wrapper>
  );
};

BewareOfScammers.propTypes = {
  className: PropTypes.string
};

export default BewareOfScammers;
